











import Debug from 'debug';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { lazyInject } from '@/app/container';
import {
  SectionProgressInterface,
  SectionProgressSymbol,
  SectionCompletion
} from '@/app/statistics/section/section-progress';
import { EventStream, EventStreamSymbol } from '@/app/event-stream/event-stream';
import { StatisticsUpdated, StatisticsUpdatedEventName } from '@/app/statistics/events/section-interaction-events';
import { TocItem } from '@/app/shared/models';
import sectionCompletionStoreModule from '@/app/statistics/state/section-completion-state';
import UiStatusBarComponent from '@/app/shared/components/ui/ui-status-bar-component.vue';

const debug = Debug('page-progress-component');

@Component({
  components: {
    UiStatusBarComponent
  }
})
export default class PageProgressComponent extends Vue {
  @Prop()
  public page: string;

  @Prop()
  public currentSection: TocItem;

  public percent: number = this.initialCompletion();
  public listenerId: string|null = null;

  @lazyInject(SectionProgressSymbol)
  private sectionProgressService: SectionProgressInterface;

  @lazyInject(EventStreamSymbol)
  private eventStream: EventStream;

  public async mounted(): Promise<void> {
    this.listenStatisticsUpdated();
  }

  public destroyed(): void {
    if (this.listenerId !== null) {
      this.eventStream.removeListener(StatisticsUpdatedEventName, this.listenerId);
    }
  }

  private listenStatisticsUpdated(): void {
    this.listenerId = this.eventStream.listen(StatisticsUpdatedEventName, (payload: StatisticsUpdated) => {
      const completion: SectionCompletion = payload.completion;

      debug('statistics-updated', completion, 'current-section', this.currentSection ? this.currentSection.id : '');

      if (completion.sectionId === this.currentSection.id) {
        this.percent = completion.progress.completion;
      }
    });
  }

  private initialCompletion(): number {
    const completion = sectionCompletionStoreModule.completionItemsBySectionId[this.currentSection.id];
    const percent = completion ? completion.progress.completion : 0;

    debug('initial-completion', percent);
    return percent;
  }
}
